import { axios } from "@/utils/request";

const serverName = "/jpaas-jrecord-web-server";

const api = {
  // 通讯录接口

  // PC登录接口
  login: "/jpaas-jim-contact-server/interface/login/pc-login",
  // 校验是否登录
  checkLogin: "/jpaas-jim-contact-server/interface/login/checkLogin",
  // 登出
  logout: "/jpaas-jim-contact-server/interface/login/logout",
  // 上传用户头像
  uploadUserAvatar: "/jpaas-jim-contact-server/front/user/uploadUserAvatar",
  // 修改用户姓名
  modifyUserName: "/jpaas-jim-contact-server/front/user/modify-user-name",
  // 修改密码
  modifyUserPwd: "/jpaas-jim-contact-server/front/user/modify-user-pwd",
  // 查询二维码状态
  checkLoginQrCode: "/jpaas-jim-contact-server/interface/login/find-qrcode-state",
  // 获取用户信息
  getUserInfo: "/jpaas-jim-contact-server/front/user/mainPage",

  // 业务接口

  // 查询快记列表
  findRecordList: serverName + "/interface/voice-transfer-text/my-record-list",
  // 获取语音转文字的ws
  getRecordWsUrl: serverName + "/interface/voice-transfer-text/find-ws-url",
  // 创建快记
  startRecord: serverName + "/interface/voice-transfer-text/start",
  // 删除快记
  remove: serverName + "/interface/voice-transfer-text/remove",
  // 暂停录制
  pause: serverName + "/interface/voice-transfer-text/pause-record",
  // 暂停后继续录制
  rePause: serverName + "/interface/voice-transfer-text/resume-record",
  // 新增发言
  addWord: serverName + "/interface/permission/speech-content/add",
  // 获取详情接口
  getInfoDetail: serverName + "/interface/voice-transfer-text/detail",
  // 获取发言列表接口
  getSpeekList: serverName + "/interface/permission/speech-content/batch-list",
  // 完成快记
  compeleteRecord: serverName + "/interface/voice-transfer-text/complete",
  // 修改发言人
  modifySpeeker: serverName + "/interface/permission/speech-content/modify-user",
  // 修改发言内容
  modifyContent: serverName + "/interface/permission/speech-content/modify-content",
  // 编辑总结内容
  modifySummary: serverName + "/interface/permission/speech-content/modify-summary",
  // 记录识别发言人状态
  recordSpeekerState: serverName + "/interface/permission/speech-content/recognize-speaker",
  // 记录角色
  addRole: serverName + "/interface/permission/speech-content/record-role",
  // 模型是否优化
  recordCorrectState: serverName + "/interface/permission/speech-content/sentence-optimize",
  // 重新生成智能总结
  redoSummary: serverName + "/interface/permission/speech-content/regenerate-summary",
  // 修改聆记名称
  modifyTitle: serverName + "/interface/voice-transfer-text/modify-title",
  // 导出
  fileExport: serverName + "/interface/permission/speech-content/fileExport",
  // 获取后台配置
  getConfig: serverName + "/interface/permission/base-config/getSystemSetting",
  // 查找模板列表
  findTemplateList: serverName + "/interface/permission/template/findTemplateList",
  // 上传AI纪要
  addTemplateContent: serverName + "/interface/permission/template/addTemplateContent",
  // 查询AI纪要详情
  detailTemplateContent: serverName + "/interface/permission/template/detailTemplateContent",
  // 切换模板时调用
  generateTemplateContent: serverName + "/interface/permission/template/generateTemplateContent",
  // 查询小模型资源
  availableResources: serverName + "/interface/permission/speech-content/available-resources",
  // 获取用户分组
  groupList: serverName + "/interface/permission/group/group-list",
  // 新建
  createGroup: serverName + "/interface/permission/group/create-group",
  // 修改
  updateGroup: serverName + "/interface/permission/group/update-group",
  // 删除
  deleteGroup: serverName + "/interface/permission/group/delete-group",
  // 添加到分组
  addToGroup: serverName + "/interface/permission/group/add-to-group",
  // 收藏
  addFavorite: serverName + "/interface/permission/favorite/add-favorite",
  // 共享收藏
  favoriteShare: serverName + "/interface/permission/share/favorite-share",
  // 取消收藏
  rcancelFavorite: serverName + "/interface/permission/favorite/cancel-favorite",
  // 共享取消收藏
  unfavoriteShare: serverName + "/interface/permission/share/unfavorite-share",
  // 用户校验
  userInfoCheck: serverName + "/interface/permission/user-check/userInfoCheck",
  // 获取推荐模版
  getRecommendTemplate: serverName + "/interface/permission/template/getRecommendTemplate",
  recommendTemplate: serverName + "/interface/permission/template/recommendTemplate",
  // 思维导图
  connect: serverName + "/interface/meeting/connect",
  trigger: serverName + "/interface/meeting/generate-map/trigger",
  getMap: serverName + "/interface/meeting/generate-map/getMap",
  addMap: serverName + "/interface/meeting/generate-map/addMap",
  // 重新生成关键词
  reKeyword: serverName + "/interface/permission/speech-content/regenerate-keyword",
  toTextAgain: serverName + "/interface/permission/file-import/toTextAgain",
  getButtonSetting: serverName + "/interface/permission/base-config/getButtonSetting",
  toTextStatusCheck: serverName + "/interface/permission/file-import/toTextStatusCheck",
  // 获取nocas配置
  globalConfig: serverName + "/interface/system/global-config",
  readNoticeClick: serverName + "/interface/permission/user-check/read-notice-click",
  queryReadNoticeClick: serverName + "/interface/permission/user-check/query-read-notice-click",
  addParagraph: serverName + "/interface/permission/record-segment/add",
  getParagraphList: serverName + "/interface/permission/record-segment/list",
  delParagraph: serverName + "/interface/permission/record-segment/delete",
  updateShareUsers: serverName + "/interface/permission/share/update-share-users",
  getShareUsers: serverName + "/interface/permission/share/share-list",
  sendInvitation: serverName + "/interface/push/send-invitation",
  checkShared: serverName + "/interface/permission/share/check-shared",
  getPublic: serverName + "/interface/permission/share/get-public",
  setPublic: serverName + "/interface/permission/share/set-public",
  setExport: serverName + "/interface/permission/share/set-export",
  getExport: serverName + "/interface/permission/share/get-export",
};

export const jqnAPI = {
  addParagraph(parameter) {
    return axios({
      url: api.addParagraph,
      method: "post",
      data: parameter,
    });
  },
  delParagraph(parameter) {
    return axios({
      url: api.delParagraph,
      method: "post",
      data: parameter,
    });
  },
  getParagraphList(parameter){
    return axios({
      url: api.getParagraphList,
      method: "get",
      params: parameter,
    });
  },
  queryReadNoticeClick(parameter) {
    return axios({
      url: api.queryReadNoticeClick,
      method: "post",
      params: parameter,
    });
  },
  readNoticeClick() {
    return axios({
      url: api.readNoticeClick,
      method: "post",
      data: {},
    });
  },
  globalConfig(parameter) {
    return axios({
      url: api.globalConfig,
      method: "get",
      params: parameter,
      data: {},
    });
  },
  toTextStatusCheck() {
    return axios({
      url: api.toTextStatusCheck,
      method: "post",
      data: {},
    });
  },
  getButtonSetting(parameter) {
    return axios({
      url: api.getButtonSetting,
      method: "post",
      data: parameter,
    });
  },
  toTextAgain(parameter) {
    return axios({
      url: api.toTextAgain,
      method: "post",
      data: parameter,
    });
  },
  reKeyword(parameter) {
    return axios({
      url: api.reKeyword,
      method: "get",
      params: parameter,
    });
  },
  addMap(parameter) {
    return axios({
      url: api.addMap,
      method: "post",
      data: parameter,
    });
  },
  getMap(parameter) {
    return axios({
      url: api.getMap,
      method: "post",
      data: parameter,
    });
  },
  trigger(parameter) {
    return axios({
      url: api.trigger,
      method: "post",
      data: parameter,
    });
  },
  connect(parameter) {
    return axios({
      url: api.connect,
      method: "get",
      params: parameter,
    });
  },
  recommendTemplate(parameter) {
    return axios({
      url: api.recommendTemplate,
      method: "post",
      data: parameter,
    });
  },
  getRecommendTemplate(parameter) {
    return axios({
      url: api.getRecommendTemplate,
      method: "post",
      data: parameter,
    });
  },
  userInfoCheck(data, parameter) {
    return axios({
      url: api.userInfoCheck,
      method: "post",
      data: data,
      params: parameter,
    });
  },
  rcancelFavorite(parameter) {
    return axios({
      url: api.rcancelFavorite,
      method: "post",
      data: parameter,
    });
  },
  unfavoriteShare(parameter) {
    return axios({
      url: api.unfavoriteShare,
      method: "post",
      data: parameter,
    });
  },
  addFavorite(parameter) {
    return axios({
      url: api.addFavorite,
      method: "post",
      data: parameter,
    });
  },
  favoriteShare(parameter) {
    return axios({
      url: api.favoriteShare,
      method: "post",
      data: parameter,
    });
  },
  
  addToGroup(parameter) {
    return axios({
      url: api.addToGroup,
      method: "post",
      data: parameter,
    });
  },
  deleteGroup(parameter) {
    return axios({
      url: api.deleteGroup,
      method: "post",
      data: parameter,
    });
  },
  updateGroup(parameter) {
    return axios({
      url: api.updateGroup,
      method: "post",
      data: parameter,
    });
  },
  createGroup(parameter) {
    return axios({
      url: api.createGroup,
      method: "post",
      data: parameter,
    });
  },
  groupList() {
    return axios({
      url: api.groupList,
      method: "get",
      data: {},
    });
  },
  availableResources() {
    return axios({
      url: api.availableResources,
      method: "post",
      data: {},
    });
  },
  completions(obj, data) {
    return axios({
      url: obj.keywordsSummaryApiUrl,
      // url: 'https://saas.hanweb.com/gateway/apps/aigc/interface/v1/chat/completions',
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${obj.sentenceOptimizeAppSecret}`, // 从环境变量获取密钥
        // Authorization:'Bearer ed3d028c07b842cba64ee6be11cb9d7e'
      },
    });
  },
  generateTemplateContent(parameter) {
    return axios({
      url: api.generateTemplateContent,
      method: "post",
      data: parameter,
    });
  },
  detailTemplateContent(parameter) {
    return axios({
      url: api.detailTemplateContent,
      method: "post",
      data: parameter,
    });
  },
  addTemplateContent(parameter) {
    return axios({
      url: api.addTemplateContent,
      method: "post",
      data: parameter,
    });
  },
  findTemplateList(parameter) {
    return axios({
      url: api.findTemplateList,
      method: "post",
      data: parameter,
    });
  },
  getConfig(parameter) {
    return axios({
      url: api.getConfig,
      method: "post",
      data: parameter,
    });
  },
  checkLoginQrCode() {
    return axios({
      url: api.checkLoginQrCode,
      method: "get",
    });
  },
  modifyUserPwd(parameter) {
    return axios({
      url: api.modifyUserPwd,
      method: "post",
      data: parameter,
    });
  },
  modifyUserName(parameter) {
    return axios({
      url: api.modifyUserName,
      method: "post",
      data: parameter,
    });
  },
  uploadUserAvatar(formData) {
    return axios({
      url: api.uploadUserAvatar,
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data", // 必须设置这个请求头
      },
    });
  },
  logout() {
    return axios({
      url: api.logout,
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
  },
  checkLogin(parameter) {
    return axios({
      url: api.checkLogin,
      method: "post",
      params: parameter,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
  },
  login(parameter) {
    return axios({
      url: api.login,
      method: "post",
      params: parameter,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
  },
  getUserInfo(parameter) {
    return axios({
      url: api.getUserInfo,
      method: "post",
      params: parameter,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        // "Access-Token":JSON.parse(localStorage.getItem('vue_ACCESS_TOKEN')).value
      },
    });
  },
  fileExport(parameter) {
    return axios({
      url: api.fileExport,
      method: "post",
      data: parameter,
    });
  },
  modifyTitle(parameter) {
    return axios({
      url: api.modifyTitle,
      method: "post",
      data: parameter,
    });
  },
  findRecordList(parameter) {
    return axios({
      url: api.findRecordList,
      method: "get",
      params: parameter,
    });
  },
  getRecordWsUrl(parameter) {
    return axios({
      url: api.getRecordWsUrl,
      method: "get",
      params: parameter,
    });
  },
  startRecord(parameter) {
    return axios({
      url: api.startRecord,
      method: "post",
      data: parameter,
    });
  },
  remove(parameter) {
    return axios({
      url: api.remove,
      method: "post",
      data: parameter,
    });
  },
  addWord(parameter) {
    return axios({
      url: api.addWord,
      method: "post",
      headers: { "Content-Type": "application/json" },
      data: parameter,
    });
  },
  pause(parameter) {
    return axios({
      url: api.pause,
      method: "post",
      data: parameter,
    });
  },
  rePause(parameter) {
    return axios({
      url: api.rePause,
      method: "post",
      data: parameter,
    });
  },
  getInfoDetail(parameter, params) {
    return axios({
      url: api.getInfoDetail,
      method: "post",
      data: parameter,
      params: params,
    });
  },
  getSpeekList(parameter) {
    return axios({
      url: api.getSpeekList,
      method: "get",
      params: parameter,
    });
  },
  compeleteRecord(parameter) {
    return axios({
      url: api.compeleteRecord,
      method: "post",
      data: parameter,
    });
  },
  modifySpeeker(parameter) {
    return axios({
      url: api.modifySpeeker,
      method: "post",
      data: parameter,
      headers: { "Content-Type": "application/json" },
    });
  },
  modifyContent(parameter) {
    return axios({
      url: api.modifyContent,
      method: "post",
      data: parameter,
      headers: { "Content-Type": "application/json" },
    });
  },
  modifySummary(parameter) {
    return axios({
      url: api.modifySummary,
      method: "post",
      data: parameter,
      headers: { "Content-Type": "application/json" },
    });
  },
  recordSpeekerState(parameter) {
    return axios({
      url: api.recordSpeekerState,
      method: "post",
      data: parameter,
      headers: { "Content-Type": "application/json" },
    });
  },
  addRole(parameter) {
    return axios({
      url: api.addRole,
      method: "post",
      headers: { "Content-Type": "application/json" },
      data: parameter,
    });
  },
  recordCorrectState(parameter) {
    return axios({
      url: api.recordCorrectState,
      method: "post",
      data: parameter,
      headers: { "Content-Type": "application/json" },
    });
  },
  redoSummary(parameter) {
    return axios({
      url: api.redoSummary,
      method: "get",
      params: parameter,
    });
  },
  updateShareUsers(parameter) {
    return axios({
      url: api.updateShareUsers,
      method: "post",
      data: parameter,
    });
  },
  getShareUsers(parameter) {
    return axios({
      url: api.getShareUsers,
      method: "get",
      params: parameter,
    });
  },
  sendInvitation(parameter) {
    return axios({
      url: api.sendInvitation,
      method: "post",
      data: parameter,
    });
  },
  checkShared(parameter) {
    return axios({
      url: api.checkShared,
      method: "get",
      params: parameter,
    });
  },
  getPublic(parameter) {
    return axios({
      url: api.getPublic,
      method: "get",
      params: parameter,
    });
  },
  setPublic(parameter) {
    return axios({
      url: api.setPublic,
      method: "post",
      data: parameter,
    });
  },
  setExport(parameter) {
    return axios({
      url: api.setExport,
      method: "post",
      data: parameter,
    });
  },
  getExport(parameter) {
    return axios({
      url: api.getExport,
      method: "get",
      params: parameter,
    });
  },
};
